// Browser-safe cache implementation using localStorage
// Replaces server-side Redis cache for frontend use

export function getJSON(key) {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    
    const parsed = JSON.parse(item);
    
    // Check if item has expired
    if (parsed.expires && Date.now() > parsed.expires) {
      localStorage.removeItem(key);
      return null;
    }
    
    return parsed.data;
  } catch (error) {
    console.warn('Cache read error:', error);
    return null;
  }
}

export function setJSON(key, data, ttlSeconds = null) {
  try {
    const item = {
      data: data,
      timestamp: Date.now(),
      expires: ttlSeconds ? Date.now() + (ttlSeconds * 1000) : null
    };
    
    localStorage.setItem(key, JSON.stringify(item));
    return true;
  } catch (error) {
    console.warn('Cache write error:', error);
    return false;
  }
}

export function clearCache() {
  try {
    // Clear only our cache items (those with timestamp structure)
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      try {
        const item = JSON.parse(localStorage.getItem(key));
        if (item && typeof item.timestamp === 'number') {
          localStorage.removeItem(key);
        }
      } catch (e) {
        // Skip non-JSON items
      }
    });
    return true;
  } catch (error) {
    console.warn('Cache clear error:', error);
    return false;
  }
}
